import { HttpClient } from "@/services/httpClient";
import { Controllers, FrappeMethodType } from "@/type/api";
import type { PosCreditVoucher, PosReturnCapabilities, PosReturnInvoice, PosReturnPreview, PosReturnRequest, PosReturnResult } from "@/type/posReturns";
import { validPosReturnTotals } from "@/services/posReturnDurability";

const service = new HttpClient(Controllers.salesInvoice);
const namespace = "pet_app.api.pos_returns";

/** All calls bypass read caches: these figures authorize money and stock writes. */
export async function posReturnsCall<T>(method: string, body: Record<string, unknown>): Promise<T> {
  const response = await service.post<any>(body, `${namespace}.${method}`, {}, {
    headers: { "X-Suppress-Error-Toast": "1" }, cache: "bypass",
  }, FrappeMethodType.method);
  const data = response?.message ?? response?.data ?? response;
  if (data == null)
    throw new Error("alkokh.posReturns.pending");
  return data as T;
}

export async function GetPosReturnCapabilities(pos_profile: string) {
  const data = await posReturnsCall<PosReturnCapabilities>("get_capabilities", { pos_profile });
  if (data.version !== 1 || !["returns", "unreceipted", "exchange", "cash_refund", "credit_sale", "quarantine_warehouse"].every(key => typeof (data as unknown as Record<string, unknown>)[key] === "boolean"))
    throw new Error("alkokh.posReturns.unavailable");
  // Reasons are display-only; anything malformed is dropped rather than trusted.
  const blocked = (data as { blocked?: unknown }).blocked;
  return { ...data, blocked: Array.isArray(blocked) ? blocked.filter((code): code is string => typeof code === "string") : [] };
}
export const SearchPosReturnInvoices = (pos_profile: string, search: string) => posReturnsCall<PosReturnInvoice[]>("search_invoices", { pos_profile, search });
export const GetPosReturnInvoice = (pos_profile: string, invoice: string) => posReturnsCall<PosReturnInvoice>("get_invoice", { pos_profile, invoice });
export async function PreviewPosReturn(request: PosReturnRequest) {
  const data = await posReturnsCall<PosReturnPreview>("preview", { request });
  if (!validPosReturnTotals(data) || typeof data.token !== "string" || !data.token || !data.currency || !Array.isArray(data.lines))
    throw new Error("alkokh.posReturns.failed");
  return data;
}
export const ListPosCreditVouchers = (pos_profile: string, customer: string, barcode = "") => posReturnsCall<PosCreditVoucher[]>("list_credit_vouchers", { pos_profile, customer, barcode });
export const ReadPosReturn = (pos_profile: string, operation: string) => posReturnsCall<PosReturnResult>("get_operation", { pos_profile, operation });
